import {Injectable} from '@angular/core';
import {CommonService} from './common.service';


@Injectable({
  providedIn: 'root'
})
export class SuperMarketRefrigeratorBudgetService {
  private serviceModel = 'super_market_budget';

  constructor(private commonService: CommonService) {
  }

  async fetchUploadedBudgetFiles() {
    return await this.commonService.getSimpleList(`${this.serviceModel}/file`);
  }

  async fetchUploadedSMBudgetFilesInfo(id: number) {
    return await this.commonService.getSimpleList(`${this.serviceModel}/${id}`);
  }

  async insertSuperMarketRefrigeratorBudget(object) {
    return await this.commonService.insertObject(`${this.serviceModel}`, object);
  }

  async setFileActivityStatus(id: number, status: number) {
    return await this.commonService.updateObject(`${this.serviceModel}/file/${id}`, {isActive: status ? 1 : 0});
  }

  async checkSMBudgetStock(data) {
    return await this.commonService.insertObject(`${this.serviceModel}/check_stock`, data);
  }

  async checkSMRedistribution(data) {
    return await this.commonService.insertObject(`${this.serviceModel}/check_for_redistribution `, data);
  }

  async updateRedistribution(data) {
    return await this.commonService.updateObject(`${this.serviceModel}/redistribution `, data);
  }
}
